// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as LangProvider from "./shared/LangProvider.re.mjs";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";
import * as Outline from "@heroicons/react/outline";
import PhotoToOilPaintingPng from "../global/images/photo-to-oil-painting.png";
import PhotoToOilPainting2xPng from "../global/images/photo-to-oil-painting@2x.png";

import { css, cx } from '@linaria/core'
;

let logo = PhotoToOilPaintingPng;

let logo2x = PhotoToOilPainting2xPng;

let style = (css`
    .banner {
      @apply -mt-3;
    }
    `);

let Root = {
  style: style
};

let style$1 = (css`
      @apply border-b-black border-b relative top-0 pt-2 pb-2 pl-3 pr-3 z-40 mb-0;
      border-bottom: 1px solid rgba(127, 127, 127, 0.3);
    `);

let OuterContainer = {
  style: style$1
};

let style$2 = (css`
      @apply grid grid-rows-1 content-end ml-auto;
      a {
        font-family: futura-pt, Helvetica, sans-serif;
        @apply pt-1 pb-1;
        -webkit-font-smoothing: antialiased;
      }
      a.dropdown:after {
        display: block;
        width: 0;
        height: 0;
        border: 6px inset;
        content: '';
        border-bottom-width: 0;
        border-top-style: solid;
        border-color: #8d6ba6 transparent transparent;
        right: 5px;
        left: auto;
        margin-top: -3px;

        position: absolute;
        @apply top-3 md:top-1/2;
      }
      a.cart {
        color: #c182f8;
      }
    `);

let Nav = {
  style: style$2
};

let style$3 = (css`
    @apply container flex flex-wrap justify-between items-center mx-auto px-4 sm:px-6 lg:px-8;
    `);

let Container = {
  style: style$3
};

let styleClosed = (css`
    @apply hidden justify-between items-center w-full md:flex md:w-auto md:order-1 ml-auto;
    > ul {
      @apply list-none md:flex md:flex-row;

      li {
        a {
          @apply md:pl-6 pr-6;
        }
        a:last-child {
          @apply pr-0;
        }
        color: #8d6ba6;
        position: relative;
      }
      > li:hover {
          div.dropdown {
            @apply md:block;
          }
      }
    }
    `);

let mobileOpen = (css`
  display: block;
    `);

let style$4 = (cx(styleClosed, mobileOpen));

let ExpandedContainer = {
  styleClosed: styleClosed,
  mobileOpen: mobileOpen,
  style: style$4
};

let style$5 = (css`
    @apply flex items-center md:order-2;
    `);

let MiniContainer = {
  style: style$5
};

let style$6 = (css`
    @apply ml-0;
    span {
      font-family: Georgia, serif;
      color: black;
      display: inline;
      line-height: 13px;
      vertical-align: text-bottom;
      font-size: 1.2em;
      font-weight: normal;
      letter-spacing: 3px;
      strong {
        font-family: helvetica;
        vertical-align: bottom;
      }
    }
  `);

let Logo = {
  style: style$6
};

let style$7 = (css`
    @apply mr-2 h-7 sm:h-7 sm:max-h-7 w-auto max-h-7;
    display: inline;
    `);

let Img = {
  style: style$7
};

let style$8 = (css`
    @apply self-center text-xl font-semibold whitespace-nowrap dark:text-white;
    `);

let LogoText = {
  style: style$8
};

let base = (css`
    @apply md:origin-top-right md:absolute md:right-0 md:w-56 md:rounded-md md:shadow-lg md:bg-white md:ring-1 md:ring-black md:ring-opacity-5 md:divide-y md:divide-gray-100 divide-gray-100 divide-y md:focus:outline-none md:pl-0 z-10;
    @apply md:hidden md:-mt-0;
    ul {
      @apply py-1;
      li a {
        @apply text-gray-700 block px-4 sm:px-5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900;
      }

    }
    `);

let styleOpen = Core.cx("dropdown", base, "block");

let styleClosed$1 = (cx('dropdown', base, 'hidden'));

let DropdownMenu = {
  base: base,
  styleOpen: styleOpen,
  styleClosed: styleClosed$1
};

let MenuIcon = {};

let XIcon = {};

let style$9 = (css`
        @apply inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600;
        span {
          @apply sr-only;
        }
        svg {
          @apply w-6 h-6;
        }
        ul {
          @apply flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium;

        }
      `);

function Nav$ExpandMenuBtn(props) {
  let __open_ = props.open_;
  let __open__value = __open_ !== undefined ? __open_ : false;
  return JsxRuntime.jsxs("button", {
    children: [
      JsxRuntime.jsx("span", {
        children: "Open main menu"
      }),
      __open__value ? JsxRuntime.jsx(Outline.XIcon, {
          "aria-hidden": "true"
        }) : JsxRuntime.jsx(Outline.MenuIcon, {
          "aria-hidden": "true"
        })
    ],
    "aria-expanded": false,
    "aria-controls": "mobile-menu",
    className: style$9,
    type: "button",
    onClick: props.onClick
  });
}

let ExpandMenuBtn = {
  MenuIcon: MenuIcon,
  XIcon: XIcon,
  style: style$9,
  make: Nav$ExpandMenuBtn
};

let style$10 = (cx(css`
        @apply relative bg-primary-900;
        &> div {
          @apply max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8;
          &> div {
            @apply pr-16 sm:text-center sm:px-16;
            p {
              @apply font-medium text-white;
              span.short {
                @apply md:hidden;
              }
              span.long {
                @apply hidden md:inline;
              }
              span.cta {
                @apply block sm:ml-2 sm:inline-block;
                a {
                  @apply text-white font-bold underline;
                }
              }
            }
          }
        }
      `, 'banner'));

function Nav$SlimBanner(props) {
  let link = props.link;
  let shortMessage = props.shortMessage;
  let message = props.message;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx("span", {
              children: shortMessage !== undefined ? shortMessage : message,
              className: "short"
            }),
            JsxRuntime.jsx("span", {
              children: message,
              className: "long"
            }),
            link !== undefined ? JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx("a", {
                  children: "Learn more",
                  href: link
                }),
                className: "cta"
              }) : null
          ]
        })
      })
    }),
    className: style$10
  });
}

let SlimBanner = {
  style: style$10,
  make: Nav$SlimBanner
};

let style$11 = (css`
        @apply container mx-auto px-4 sm:px-6 lg:px-8;
      `);

function Nav$LayoutContainer(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: style$11
  });
}

let LayoutContainer = {
  style: style$11,
  make: Nav$LayoutContainer
};

function Nav$NavLink(props) {
  let children = props.children;
  let role = props.role;
  let className = props.className;
  let to = props.to;
  if (to.TAG === "Route") {
    return JsxRuntime.jsx(LangProvider.Router.Link.make, {
      to: to._0,
      children: children,
      className: className,
      role: role
    });
  } else {
    return JsxRuntime.jsx("a", {
      children: children,
      className: className,
      role: role,
      href: to._0
    });
  }
}

let NavLink = {
  make: Nav$NavLink
};

function toReact(param) {
  let title = param.title;
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsx(Nav$NavLink, {
      to: param.link,
      role: "menuitem",
      children: title
    }),
    role: "none"
  }, title);
}

let MenuItem = {
  toReact: toReact
};

let MenuItemEl = {
  fromDomain: toReact
};

function toReact$1(items) {
  return JsxRuntime.jsx("ul", {
    children: Belt_Array.map(items, toReact),
    className: "dropdown",
    role: "none"
  });
}

let MenuSection = {
  toReact: toReact$1
};

let MenuSectionEl = {
  fromDomain: toReact$1
};

let galleryProducts = [
  {
    title: "Oil Painting",
    link: {
      TAG: "Legacy",
      _0: "/gallery/featured/paintings"
    }
  },
  {
    title: "Watercolor Painting",
    link: {
      TAG: "Legacy",
      _0: "/gallery/featured/watercolor"
    }
  },
  {
    title: "Colored Pencil Drawing",
    link: {
      TAG: "Legacy",
      _0: "/gallery/featured/colored-pencil"
    }
  },
  {
    title: "Charcoal Drawing",
    link: {
      TAG: "Legacy",
      _0: "/gallery/featured/charcoal"
    }
  },
  {
    title: "Pencil Drawing",
    link: {
      TAG: "Legacy",
      _0: "/gallery/featured/pencil"
    }
  }
];

let galleryFeaturedSubjects = [
  {
    title: "Portrait Paintings",
    link: {
      TAG: "Route",
      _0: "/portrait-paintings"
    }
  },
  {
    title: "Pet Portraits",
    link: {
      TAG: "Legacy",
      _0: "/gallery/pet-portraits"
    }
  },
  {
    title: "Wedding Paintings",
    link: {
      TAG: "Legacy",
      _0: "/gallery/wedding-paintings"
    }
  },
  {
    title: "Baby and Kids Paintings",
    link: {
      TAG: "Legacy",
      _0: "/gallery/baby-paintings"
    }
  },
  {
    title: "Landscape, Abstract, and Other",
    link: {
      TAG: "Legacy",
      _0: "/gallery/landscape-paintings"
    }
  }
];

let gallerySubjects = [
  {
    title: "Artistic Style Paintings",
    link: {
      TAG: "Legacy",
      _0: "/gallery/style-paintings"
    }
  },
  {
    title: "Replace Face/Royal Portraits",
    link: {
      TAG: "Legacy",
      _0: "/gallery/reface"
    }
  },
  {
    title: "Change Background",
    link: {
      TAG: "Legacy",
      _0: "/gallery/replace-background"
    }
  },
  {
    title: "Change or Adjust Something",
    link: {
      TAG: "Legacy",
      _0: "/gallery/change-things"
    }
  },
  {
    title: "Add People or Things",
    link: {
      TAG: "Legacy",
      _0: "/gallery/add-things"
    }
  },
  {
    title: "Remove People or Things",
    link: {
      TAG: "Legacy",
      _0: "/gallery/remove-things"
    }
  },
  {
    title: "Merge Photos",
    link: {
      TAG: "Legacy",
      _0: "/gallery/merge-photos"
    }
  },
  {
    title: "Classical Replicas",
    link: {
      TAG: "Legacy",
      _0: "/gallery/replica-painting"
    }
  },
  {
    title: "Restore an Old Photo",
    link: {
      TAG: "Legacy",
      _0: "/gallery/restore-photo"
    }
  }
];

let products = [
  {
    title: "Oil Painting",
    link: {
      TAG: "Legacy",
      _0: "/products/custphotoreal"
    }
  },
  {
    title: "Watercolor Painting",
    link: {
      TAG: "Legacy",
      _0: "/products/custwatercolor"
    }
  },
  {
    title: "Colored Pencil Drawing",
    link: {
      TAG: "Legacy",
      _0: "/products/custcoloredpencil"
    }
  },
  {
    title: "Charcoal Drawing",
    link: {
      TAG: "Legacy",
      _0: "/products/custcharcoal"
    }
  },
  {
    title: "Pencil Drawing",
    link: {
      TAG: "Legacy",
      _0: "/products/custpencil"
    }
  }
];

function Nav$1(props) {
  let logoSize = {
    width: 45,
    height: 50
  };
  let match = React.useState(() => false);
  let setMobile = match[1];
  let mobile = match[0];
  let match$1 = React.useState(() => false);
  let setGalleryOpen = match$1[1];
  let match$2 = React.useState(() => false);
  let setProductsOpen = match$2[1];
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("header", {
      children: JsxRuntime.jsx("nav", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs(Nav$NavLink, {
              to: {
                TAG: "Route",
                _0: "/"
              },
              className: style$6,
              children: [
                JsxRuntime.jsx("img", {
                  className: style$7,
                  alt: "Instapainting Logo",
                  height: String(logoSize.height),
                  src: logo,
                  srcSet: logo2x + " 2x",
                  width: String(logoSize.width)
                }),
                JsxRuntime.jsx("span", {
                  children: "INSTAPAINTING"
                })
              ]
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("ul", {
                    children: [
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsx(Nav$NavLink, {
                          to: {
                            TAG: "Legacy",
                            _0: "/carts/checkout"
                          },
                          children: "GALLERY"
                        })
                      }),
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsx(Nav$NavLink, {
                          to: {
                            TAG: "Legacy",
                            _0: "/support"
                          },
                          children: "HELP"
                        })
                      }),
                      JsxRuntime.jsx("li", {
                        children: JsxRuntime.jsxs(Nav$NavLink, {
                          to: {
                            TAG: "Legacy",
                            _0: "/carts/checkout"
                          },
                          className: "cart",
                          children: [
                            JsxRuntime.jsx("i", {
                              className: "fi-shopping-cart"
                            }),
                            " CART"
                          ]
                        })
                      })
                    ],
                    "aria-labelledby": "dropdown"
                  }),
                  className: styleClosed$1
                }),
                JsxRuntime.jsx(Nav$ExpandMenuBtn, {
                  onClick: e => {
                    e.preventDefault();
                    setMobile(prev => !prev);
                  },
                  open_: mobile
                })
              ],
              className: style$5
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("ul", {
                children: [
                  JsxRuntime.jsxs("li", {
                    children: [
                      JsxRuntime.jsx("a", {
                        children: "GALLERY",
                        className: "dropdown",
                        id: "gallery-dropdown",
                        href: "#",
                        onClick: e => {
                          e.preventDefault();
                          setGalleryOpen(prev => !prev);
                        }
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          toReact$1(galleryProducts),
                          toReact$1(galleryFeaturedSubjects),
                          toReact$1(gallerySubjects)
                        ],
                        "aria-labelledby": "gallery-dropdown",
                        className: match$1[0] ? styleOpen : styleClosed$1,
                        role: "menu"
                      })
                    ],
                    className: "menu-item",
                    role: "none"
                  }),
                  JsxRuntime.jsxs("li", {
                    children: [
                      JsxRuntime.jsx("a", {
                        children: "PRODUCTS & PRICING",
                        className: "dropdown",
                        id: "products-dropdown",
                        href: "#",
                        onClick: e => {
                          e.preventDefault();
                          setProductsOpen(prev => !prev);
                        }
                      }),
                      JsxRuntime.jsx("div", {
                        children: toReact$1(products),
                        "aria-labelledby": "products-dropdown",
                        className: match$2[0] ? styleOpen : styleClosed$1,
                        role: "menu"
                      })
                    ],
                    role: "none"
                  }),
                  JsxRuntime.jsx("li", {
                    children: JsxRuntime.jsx(Nav$NavLink, {
                      to: {
                        TAG: "Legacy",
                        _0: "/support"
                      },
                      children: "HELP"
                    }),
                    role: "none"
                  }),
                  JsxRuntime.jsx("li", {
                    children: JsxRuntime.jsxs(Nav$NavLink, {
                      to: {
                        TAG: "Legacy",
                        _0: "/carts/checkout"
                      },
                      className: "cart",
                      children: [
                        JsxRuntime.jsx("i", {
                          className: "fi-shopping-cart"
                        }),
                        " CART"
                      ]
                    }),
                    role: "none"
                  })
                ],
                role: "menubar"
              }),
              className: mobile ? style$4 : styleClosed,
              id: "mobile-menu"
            })
          ],
          className: style$3
        }),
        className: style$2
      }),
      className: style$1
    }),
    className: style
  });
}

let make = Nav$1;

let $$default = Nav$1;

export {
  logo,
  logo2x,
  Root,
  OuterContainer,
  Nav,
  Container,
  ExpandedContainer,
  MiniContainer,
  Logo,
  Img,
  LogoText,
  DropdownMenu,
  ExpandMenuBtn,
  SlimBanner,
  LayoutContainer,
  NavLink,
  MenuItem,
  MenuItemEl,
  MenuSection,
  MenuSectionEl,
  galleryProducts,
  galleryFeaturedSubjects,
  gallerySubjects,
  products,
  make,
  $$default as default,
}
/*  Not a pure module */
